import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { ClipboardText } from "@phosphor-icons/react";

const Bar = styled.div`
  display: flex;
  align-items: center;
  gap: ${(p) => (p.$compact ? "8px" : "12px")};
  flex-wrap: ${(p) => (p.$compact ? "wrap" : "nowrap")};
  padding: ${(p) => (p.$compact ? "6px 8px" : "8px 12px")};
  margin-bottom: 8px;
  background: #eefbf3;
  border: 1px solid #b7e4c7;
  border-radius: 8px;
  font-family: "Manrope", sans-serif;
  font-size: ${(p) => (p.$compact ? "12px" : "13px")};
  color: #177a3e;
`;

const CountText = styled.span`
  font-weight: 600;
`;

const Spacer = styled.div`
  flex: 1;
`;

const PasteButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: none;
  border-radius: 6px;
  background: #177a3e;
  color: #fff;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  padding: 6px 14px;
  cursor: pointer;

  &:disabled {
    background: #aeb8c4;
    cursor: not-allowed;
  }
`;

const CompactBar = styled(Bar)`
  flex-wrap: wrap;
  margin: 8px 0 0;
  padding: 8px;
  gap: 8px;
`;

const ClipboardPasteBar = ({
  count,
  destinationName,
  onPaste,
  pasting = false,
  compact = false,
}) => {
  if (!count) return null;
  const dest = destinationName ? ` into ${destinationName}` : "";
  const Wrapper = compact ? CompactBar : Bar;
  return (
    <Wrapper data-testid="clipboard-paste-bar">
      <CountText data-testid="clipboard-paste-count">
        {count} file{count === 1 ? "" : "s"} copied
      </CountText>
      {!compact && (
        <span>Paste{dest} to add {count === 1 ? "a copy" : "copies"} here.</span>
      )}
      <Spacer />
      <PasteButton
        type="button"
        data-testid="clipboard-paste-button"
        disabled={pasting || typeof onPaste !== "function"}
        onClick={onPaste}
      >
        <ClipboardText size={16} weight="regular" />
        {pasting ? "Pasting…" : compact ? `Paste${dest}` : `Paste ${count} file${count === 1 ? "" : "s"}`}
      </PasteButton>
    </Wrapper>
  );
};

ClipboardPasteBar.propTypes = {
  count: PropTypes.number,
  destinationName: PropTypes.string,
  onPaste: PropTypes.func,
  pasting: PropTypes.bool,
  compact: PropTypes.bool,
};

export default ClipboardPasteBar;
